"use client";

import { cn } from "@workspace/frontend-ui";
import type { HighlightedGameSlide } from "./types";

type Props = {
  slides: HighlightedGameSlide[];
  selectedIndex: number;
  progress: number;
  onSelect: (index: number) => void;
};

const HeroDots: FC<Props> = ({ slides, selectedIndex, progress, onSelect }) => (
  <div className="flex items-center justify-center gap-3 md:hidden">
    {slides.map((slide, index) => {
      const isSelected = index === selectedIndex;

      return (
        <button
          key={slide.id}
          type="button"
          aria-label={slide.title}
          aria-current={isSelected}
          onClick={() => onSelect(index)}
          className="relative flex shrink-0 cursor-pointer items-center"
        >
          <span
            aria-hidden="true"
            className="-inset-x-1.5 -inset-y-3 absolute"
          />
          <span
            className={cn(
              "relative h-2 overflow-hidden rounded-full bg-secondary transition-[width] duration-500 ease-out motion-reduce:transition-none",
              isSelected ? "w-15" : "w-2",
            )}
          >
            {isSelected && (
              <span
                aria-hidden="true"
                data-slot="hero-dot-progress"
                className="absolute inset-y-0 left-0 rounded-full bg-primary rtl:right-0 rtl:left-auto"
                style={{ width: `${progress * 100}%` }}
              />
            )}
          </span>
        </button>
      );
    })}
  </div>
);

export default HeroDots;
